import React from 'react'
import { NavMain } from '@/components/nav-main'
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  useSidebar,
} from '@/components/ui/sidebar'
import logo from '@/assets/images/hydra_score_head_sm.webp'
import { cn } from '@/lib/utils'
import { useNavigate } from 'react-router'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { open, isMobile, openMobile, toggleSidebar, state } = useSidebar()

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader
        className={cn('min-h-[70px] p-0 py-0 items-center justify-center', {
          'md:pl-10 items-start': state === 'expanded',
        })}
      >
        {isMobile && openMobile ? (
          <div className="flex justify-between items-center pl-10 w-full px-5">
            <LogoImage />
            <ExpandedToggleIcon
              icon={
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                    stroke="#202224"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 3V21M16 15L13 12L16 9"
                    stroke="#202224"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              toggleSidebar={toggleSidebar}
            />
          </div>
        ) : open ? (
          <LogoImage />
        ) : (
          <ExpandedToggleIcon toggleSidebar={toggleSidebar} />
        )}
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
    </Sidebar>
  )
}

const LogoImage = () => {
  const navigate = useNavigate()
  return (
    <div className="cursor-pointer" onClick={() => navigate('/')}>
      <img src={logo} width={168} height={40} alt="logo" />
    </div>
  )
}

const ExpandedToggleIcon = ({
  toggleSidebar,
  icon,
}: {
  toggleSidebar: () => void
  icon?: React.ReactNode
}) => {
  return (
    <div className=" cursor-pointer" onClick={() => toggleSidebar()}>
      {icon ? (
        icon
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
            stroke="#202224"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 3V21M14 9L17 12L14 15"
            stroke="#202224"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </div>
  )
}
